import React from "react";

import { Checkbox } from "Components/atoms/Checkbox";
import { Typography } from "Components/atoms/Typography";
import { FilterElement } from "../FilterElement";

import { AirportItem, AirportsFilterWrapper } from "./styles";
import { AirportsFilterProps } from "./types";

/**
 * Componente AirportsFilter
 *
 * Exibe uma lista de aeroportos para seleção com base em filtros.
 *
 * @param {AirportsFilterItem[]} airports - Lista de aeroportos filtrados.
 * @param {string} originAirport - Código do aeroporto de origem.
 * @param {(item: AirportsFilterItem, isChecked: boolean) => void} onChange - Callback executado ao alterar a seleção de um aeroporto.
 * @param {'origin' | 'destination'} type - Indica se o filtro é para origem ou destino.
 */
export const AirportsFilter: React.FC<AirportsFilterProps> = ({
  originAirport,
  airports,
  onChange,
  type,
  onToggleAll,
}) => {
  const iconName = type === "origin" ? "FaPlaneDeparture" : "FaPlaneArrival";

  return (
    <AirportsFilterWrapper>
      <FilterElement
        title={originAirport}
        iconName={iconName}
        onToggleAll={airports.length ? onToggleAll : undefined}
      >
        {airports?.map((airport, index) => (
          <AirportItem key={index}>
            <Checkbox
              name="airports"
              value={airport.iata}
              isChecked={airport.isChecked}
              color="black"
              label={airport.iata}
              onChange={(value) =>
                onChange(airport, value === airport.iata && !airport.isChecked)
              }
            />
            <Typography variant="body" weight="extraLight" color="black">
              {airport.name}
            </Typography>
          </AirportItem>
        ))}
      </FilterElement>
    </AirportsFilterWrapper>
  );
};
